import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'nexumDocument',
  type: 'nexum--document',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    data: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'data',
    },
    uri: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'uri',
    },
    url: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'real_path',
    },
  },
  relationships: {
    user: {
      type: 'user--user',
      required: false,
      isArray: false,
      name: 'uid',
    },
  },
};
export const NexumDocumentService = createService(base, configuration, API_CONFIG.API);
export const NexumDocumentModule = createModule(NexumDocumentService, true);



// WEBPACK FOOTER //
// ./src/models/nexumDocument.js